import React from "react";
import { useNavigate } from "react-router-dom";
import { doors } from "../door.js";
import "./Home.css";
function Home() {
  const navigate = useNavigate();

  const [page, setPage] = React.useState(0);
  const handleDoorClick = (doorId) => {
    navigate(`/door/${doorId}`);
  };

  return (
    <div className="home">
      <h1>Select a Door</h1>
      <div className="navigation-buttons">
        <button
          className="vision-button"
          onClick={() => navigate("/homevision")}
        >
          Try Home Vision
        </button>
      </div>
      <div className="pagination">
        <button onClick={() => setPage(page - 1)} disabled={page === 0}>
          Previous
        </button>
        <span className="page-info">
          Page {page + 1} of {Math.ceil(doors.length / 50)}
        </span>
        <select
          value={page}
          onChange={(e) => setPage(Number(e.target.value))}
          className="page-selector"
        >
          {Array.from({ length: Math.ceil(doors.length / 50) }, (_, i) => (
            <option key={i} value={i}>
              Page {i + 1}
            </option>
          ))}
        </select>
        <button
          onClick={() => setPage(page + 1)}
          disabled={50 + 50 * page >= doors.length}
        >
          Next
        </button>
      </div>
      <div className="door-grid">
        {doors
          .slice(0 + 50 * page, Math.min(50 + 50 * page, doors.length))
          .map((door, idx) => (
            <div
              key={door.id}
              className="door-card"
              onClick={() => handleDoorClick(50 * page + idx)}
            >
              <img src={door.image} alt={door.name} />
              <h3>{door.name}</h3>
            </div>
          ))}
      </div>
    </div>
  );
}

export default Home;
